// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10DMO","textarea":"styles_textarea__fj5xh"};